

<div class="home-page" *ngIf="isDesktop" >
      <div class="slide1"></div>
      <div class="slide2"></div>
      <div class="slide3"></div>
      <div class="slide4"></div>
      <div class="slide5"></div>
  </div>

  <div class="home-page" *ngIf="isIpad">
      <div class="slide1"></div>
      <div class="slide2"></div>
      <div class="slide3"></div>
      <div class="slide4"></div>
      <div class="slide5"></div>
  </div>

  <div class="mobile-home-page" *ngIf="isMobile">
      <div class="mobile-slide1"></div>
      <div class="mobile-slide2"></div>
      <div class="mobile-slide3"></div>
      <div class="mobile-slide4"></div>
      <div class="mobile-slide5"></div>
  </div>